(() => {
  if (window.__nutribotaTrackingLoaded) return;
  window.__nutribotaTrackingLoaded = true;
  window.dataLayer = window.dataLayer || [];

  const path = () => window.location.pathname || '/';
  const cleanText = (value) => (value || '').replace(/\s+/g, ' ').trim().slice(0, 120);
  const push = (event, detail = {}) => {
    window.dataLayer.push({ event, ...detail });
  };

  const onReady = () => {
    const currentPath = path();
    if (currentPath.startsWith('/products/')) {
      push('nutribota_product_view', {
        page_path: currentPath,
        page_title: document.title,
        flagship: currentPath.includes('/products/nutribota-creatine-stick-packs-5g-60-count')
      });
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (link) {
      let destination;
      try { destination = new URL(link.href, window.location.origin); } catch (e) { destination = null; }
      if (destination && destination.origin === window.location.origin) {
        const fromPath = path();
        const toPath = destination.pathname;
        const trackedDestination =
          toPath.startsWith('/products/') ||
          toPath === '/collections/creatine' ||
          toPath === '/pages/quality-transparency' ||
          toPath === '/pages/why-stick-packs' ||
          toPath.includes('/blogs/news/what-is-purest-creatine');

        if (trackedDestination) {
          push('nutribota_cta_click', {
            from_path: fromPath,
            destination_path: toPath,
            link_text: cleanText(link.textContent)
          });
        }

        if (fromPath.startsWith('/blogs/') && toPath.startsWith('/products/')) {
          push('nutribota_blog_product_click', {
            from_path: fromPath,
            destination_path: toPath,
            link_text: cleanText(link.textContent)
          });
        } else if (fromPath.startsWith('/blogs/') && toPath === '/collections/creatine') {
          push('nutribota_blog_creatine_hub_click', {
            from_path: fromPath,
            destination_path: toPath,
            link_text: cleanText(link.textContent)
          });
        }
      }
    }

    const checkoutControl = event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
    if (checkoutControl) {
      push('nutribota_checkout_click', { from_path: path() });
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return;
    const quantity = form.querySelector('[name="quantity"]')?.value || '1';
    const variantId = form.querySelector('[name="id"]')?.value || '';
    push('nutribota_add_to_cart', {
      from_path: path(),
      quantity,
      variant_id: variantId
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }
})();

(() => {
  if (window.__nbSignupTrackingLoaded) return;
  window.__nbSignupTrackingLoaded = true;
  const storageKey = 'nb_signup_pending_v2';
  const testKey = 'nb_signup_test_session_v1';
  const maxAge = 30 * 60 * 1000;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const read = () => {
    try { return JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) { return null; }
  };
  const clear = () => { try { sessionStorage.removeItem(storageKey); } catch (_) {} };
  const testVisit = () => {
    if (!allowed()) return false;
    const query = new URLSearchParams(window.location.search);
    const flag = query.get('nb_test') ?? query.get('nb_qa');
    let referrerHost = '';
    try { referrerHost = new URL(document.referrer).hostname; } catch (_) {}
    const preview = window.Shopify?.designMode === true ||
      (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') ||
      query.has('preview_theme_id') || query.has('preview_script_id');
    const source = (query.get('utm_source') || '').trim().toLowerCase();
    const medium = (query.get('utm_medium') || '').trim().toLowerCase();
    const internal = preview || referrerHost === 'admin.shopify.com' || source === 'qa' || medium === 'test' || medium === 'internal';
    let previous = null;
    try { previous = JSON.parse(sessionStorage.getItem(testKey) || 'null'); } catch (_) {}
    const current = Date.now();
    const active = !!internal || flag === '1' || (flag !== '0' &&
      Number.isFinite(previous?.time) && current >= previous.time && current - previous.time < maxAge);
    try {
      if (active) sessionStorage.setItem(testKey, JSON.stringify({time: current}));
      else sessionStorage.removeItem(testKey);
    } catch (_) {}
    return active;
  };
  const tagTestSignup = (form) => {
    const query = new URLSearchParams(window.location.search);
    let referrerHost = '';
    try { referrerHost = new URL(document.referrer).hostname; } catch (_) {}
    const preview = window.Shopify?.designMode === true ||
      (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') ||
      query.has('preview_theme_id') || query.has('preview_script_id');
    const source = (query.get('utm_source') || '').trim().toLowerCase();
    const medium = (query.get('utm_medium') || '').trim().toLowerCase();
    const explicit = preview || (query.get('nb_test') ?? query.get('nb_qa')) === '1' || referrerHost === 'admin.shopify.com' ||
      source === 'qa' || medium === 'test' || medium === 'internal';
    const isTest = !!explicit || testVisit();
    if (isTest) {
      const field = form.querySelector('input[name="contact[tags]"]');
      if (field) {
        const tags = (field.value || '').split(',').map(tag => tag.trim()).filter(Boolean);
        if (!tags.includes('nutribota-qa')) tags.push('nutribota-qa');
        field.value = tags.join(',');
      }
    }
    return isTest;
  };
  window.nutribotaIsTestVisit = testVisit;
  let sent = false;
  const report = () => {
    if (!allowed() || sent) return;
    const pending = read();
    if (!pending) return;
    if (!Number.isFinite(pending.time) || Date.now() < pending.time || Date.now() - pending.time > maxAge) { clear(); return; }
    if (!['home', 'product', 'article'].includes(pending.location)) { clear(); return; }
    if (pending.path !== window.location.pathname) return;
    const accepted = document.querySelector('[data-nb-signup-success="' + pending.location + '"]');
    const rejected = document.querySelector('[data-nb-signup-error="' + pending.location + '"]');
    if (!accepted && !rejected) return;
    sent = true;
    clear();
    const isTest = pending.test === true || testVisit();
    const params = {
      send_to: 'G-8TF9FDW2J6',
      form_location: pending.location,
      signup_page: pending.path,
      subscription_result: accepted ? 'form_accepted' : 'form_rejected',
      signup_test: isTest ? 'yes' : 'no'
    };
    if (isTest) { params.debug_mode = true; params.traffic_type = 'internal'; }
    window.dataLayer = window.dataLayer || [];
    const gtag = typeof window.gtag === 'function' ? window.gtag : function () { window.dataLayer.push(arguments); };
    gtag('event', accepted ? (isTest ? 'nb_launch_signup_test' : 'nb_newsletter_form_accepted') : ('nb_newsletter_form_error' + (isTest ? '_test' : '')), params);
  };
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches?.('form[data-nb-signup]')) return;
    const location = form.getAttribute('data-nb-signup');
    if (!['home', 'product', 'article'].includes(location)) return;
    const isTest = tagTestSignup(form);
    if (!allowed()) return;
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({
        location,
        path: window.location.pathname,
        time: Date.now(),
        test: isTest
      }));
    } catch (_) {}
  }, true);
  const ready = () => {
    const check = () => { testVisit(); report(); };
    if (window.Shopify?.customerPrivacy) check();
    else if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], (error) => { if (!error) check(); });
    }
  };
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) {
      clear();
      try { sessionStorage.removeItem(testKey); } catch (_) {}
    } else { testVisit(); report(); }
  });
  window.addEventListener('load', ready, {once:true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});
  else ready();
})();

(() => {
  if (window.__nbContentTrackingLoaded) return;
  window.__nbContentTrackingLoaded = true;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const testVisit = () => window.nutribotaIsTestVisit?.() === true;
  document.addEventListener('click', (event) => {
    if (!allowed() || !event.isTrusted || event.defaultPrevented) return;
    const source = window.location.pathname;
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?blogs\/[^/]+\/[^/]+\/?$/i.test(source)) return;
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    let destination;
    try { destination = new URL(link.href, window.location.origin); } catch (_) { return; }
    if (destination.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(destination.pathname)) return;
    const params = {
      send_to: 'G-8TF9FDW2J6',
      content_page: source,
      destination_path: destination.pathname,
      link_id: ['5g_label_comparison', 'packets_cost_comparison', 'portable_packing_checklist', 'buyer_documented_example', 'coa_documented_example', 'storage_product_facts'].includes(link.getAttribute('data-nb-cta-location'))
        ? link.getAttribute('data-nb-cta-location')
        : (link.closest('.nb-article-reading') ? 'article_reading_footer' : 'article_other'),
      link_text: (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120),
      content_test: testVisit() ? 'yes' : 'no',
      transport_type: 'beacon'
    };
    if (params.content_test === 'yes') {
      params.debug_mode = true;
      params.traffic_type = 'internal';
    }
    window.dataLayer = window.dataLayer || [];
    const gtag = typeof window.gtag === 'function' ? window.gtag : function () { window.dataLayer.push(arguments); };
    gtag('event', params.content_test === 'yes' ? 'nb_content_product_click_test' : 'nb_content_product_click', params);
  });
})();


/* Finished-report and quality-page navigation measurement, 2026-10-04. */
;(function () {
  'use strict';
  var productPath = '/products/nutribota-creatine-stick-packs-5g-60-count';
  function normalize(path) { return path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '').replace(/\/$/, ''); }
  document.addEventListener('click', function (event) {
    if (!event.isTrusted || event.defaultPrevented) return;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || privacy.analyticsProcessingAllowed() !== true) return;
    var link = event.target && event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var destination;
    try { destination = new URL(link.href, window.location.href); } catch (_) { return; }
    var source = normalize(window.location.pathname);
    var params = { content_page: source, destination_path: destination.pathname, send_to: 'G-8TF9FDW2J6', transport_type: 'beacon' };
    var name;
    if (destination.hostname === 'cdn.shopify.com' && /^\/s\/files\/.*\/nutribota-finished-product-test-report-vb26097500-sgs-20260924(?:_|\.jpg)/.test(destination.pathname)) {
      name = 'nb_finished_report_open';
      params.report_id = 'GZF26-0057291-01';
      params.batch_number = 'VB26097500';
      params.link_id = ['finished_batch_report', 'product_batch_summary'].includes(link.getAttribute('data-nb-document-location')) ? link.getAttribute('data-nb-document-location') : 'finished_report_other';
    } else if (source === '/pages/quality-transparency' && destination.origin === window.location.origin && normalize(destination.pathname) === productPath) {
      name = 'nb_quality_product_click';
      params.link_id = link.getAttribute('data-nb-cta-location') === 'quality_batch_summary' ? 'quality_batch_summary' : 'quality_other';
    } else return;
    var test = typeof window.nutribotaIsTestVisit === 'function' && window.nutribotaIsTestVisit();
    params.content_test = test ? 'yes' : 'no';
    if (test) {
      name += '_test';
      params.debug_mode = true;
      params.traffic_type = 'internal';
    }
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
    else { window.dataLayer = window.dataLayer || []; (function () { window.dataLayer.push(arguments); })('event', name, params); }
  });
})();

(() => {
  const ready = () => {
    const bar = document.querySelector('[data-nb-mobile-launch]');
    const amazonPurchase = bar?.hasAttribute('data-nb-amazon-purchase');
    const signup = amazonPurchase ? document.querySelector('.nb-amazon-entry') : document.querySelector('#nb-product-availability form');
    if (!bar || !signup || !window.matchMedia) return;
    const phone = window.matchMedia('(max-width: 749px)');
    let signupVisible = false;
    let footerVisible = false;
    const sync = () => {
      const typing = document.activeElement?.matches('input,textarea,select');
      const menu = document.querySelector('header details[open]');
      const accepted = !amazonPurchase && document.querySelector('[data-nb-signup-success="product"]');
      bar.hidden = !phone.matches || signupVisible || footerVisible || typing || !!menu || !!accepted;
      document.body.classList.toggle('nb-mobile-launch-enabled', phone.matches && !accepted);
    };
    if ('IntersectionObserver' in window) {
      const footer = document.querySelector('footer, [role="contentinfo"]');
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === signup) signupVisible = entry.isIntersecting;
          if (entry.target === footer) footerVisible = entry.isIntersecting;
        });
        sync();
      });
      observer.observe(signup);
      if (footer) observer.observe(footer);
    }
    phone.addEventListener('change', sync);
    document.addEventListener('focusin', sync);
    document.addEventListener('focusout', () => setTimeout(sync, 0));
    document.addEventListener('toggle', sync, true);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});
  else ready();
})();

(() => {
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const fire = (name, detail) => {
    if (!allowed()) return;
    const test = window.nutribotaIsTestVisit?.() === true;
    const params = {send_to:'G-8TF9FDW2J6', ...detail, signup_test:test ? 'yes' : 'no', content_test:test ? 'yes' : 'no', transport_type:'beacon'};
    if (test) { params.debug_mode = true; params.traffic_type = 'internal'; }
    window.dataLayer = window.dataLayer || [];
    const gtag = typeof window.gtag === 'function' ? window.gtag : function () { window.dataLayer.push(arguments); };
    gtag('event', name + (test ? '_test' : ''), params);
  };
  document.addEventListener('click', event => {
    if (!event.isTrusted || event.defaultPrevented) return;
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    let target;
    try { target = new URL(link.href, window.location.origin); } catch (_) { return; }
    if (target.origin !== window.location.origin || target.pathname !== window.location.pathname) return;
    const locations = {'#nutribota-launch':'home', '#nb-product-availability':'product', '#nutribota-article-signup':'article'};
    const location = locations[target.hash];
    if (!location) return;
    fire('nb_launch_signup_click', {form_location:location, signup_page:window.location.pathname, link_id:link.getAttribute('data-nb-launch-location') || 'page_signup_link'});
  });
  document.addEventListener('submit', event => {
    if (!event.isTrusted || !event.target.matches?.('form[data-nb-signup]')) return;
    const location = event.target.getAttribute('data-nb-signup');
    if (!['home','product','article'].includes(location)) return;
    fire('nb_newsletter_submit_attempt', {form_location:location, signup_page:window.location.pathname});
  }, true);
  const seen = new WeakSet();
  const completed = new WeakSet();
  document.addEventListener('play', event => {
    const video = event.target;
    if (!video.matches?.('video[data-nb-video-id]') || seen.has(video) || !allowed()) return;
    seen.add(video);
    fire('nb_video_play', {content_page:window.location.pathname, video_id:video.getAttribute('data-nb-video-id'), video_provider:'html5'});
  }, true);
  document.addEventListener('ended', event => {
    const video = event.target;
    if (!video.matches?.('video[data-nb-video-id]') || !seen.has(video) || completed.has(video) || !allowed()) return;
    completed.add(video);
    fire('nb_video_complete', {content_page:window.location.pathname, video_id:video.getAttribute('data-nb-video-id'), video_provider:'html5'});
  }, true);
})();

(() => {
  if (window.__nbSignupFeedbackLoaded) return;
  window.__nbSignupFeedbackLoaded = true;
  const timers = new Map();
  const reset = form => {
    clearTimeout(timers.get(form));
    timers.delete(form);
    form.removeAttribute('aria-busy');
    const button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = false;
    const status = form.querySelector('[data-nb-signup-status]');
    if (status) { status.hidden = true; status.textContent = ''; }
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches?.('form[data-nb-signup]') || event.defaultPrevented) return;
    queueMicrotask(() => {
      if (event.defaultPrevented) return;
      const status = form.querySelector('[data-nb-signup-status]');
      const button = form.querySelector('button[type="submit"]');
      if (!status || !button) return;
      form.setAttribute('aria-busy', 'true');
      status.textContent = status.dataset.submitting;
      status.hidden = false;
      button.disabled = true;
      clearTimeout(timers.get(form));
      timers.set(form, setTimeout(() => {
        form.removeAttribute('aria-busy');
        button.disabled = false;
        status.textContent = status.dataset.waiting;
        timers.delete(form);
      }, 15000));
    });
  }, true);
  window.addEventListener('pageshow', event => {
    if (event.persisted) document.querySelectorAll('form[data-nb-signup]').forEach(reset);
  });
})();

(() => {
  const ready = () => {
    const article = document.querySelector('article.article-template--nb');
    if (!article) return;
    const regions = [];
    article.querySelectorAll('.rte table').forEach(table => {
      if (table.closest('[role="region"]')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'nb-table-scroll';
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', article.dataset.nbTableLabel);
      const columns = Array.from(table.rows[0]?.cells || []).reduce((total, cell) => total + cell.colSpan, 0);
      if (columns > 2) table.setAttribute('data-nb-wide-table', '');
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
      const hint = document.createElement('p');
      hint.className = 'nb-table-hint';
      hint.textContent = article.dataset.nbTableHint;
      hint.hidden = true;
      wrapper.after(hint);
      regions.push({wrapper, hint});
    });
    const sync = () => regions.forEach(({wrapper, hint}) => {
      const overflowing = wrapper.scrollWidth > wrapper.clientWidth + 1;
      wrapper.tabIndex = overflowing ? 0 : -1;
      hint.hidden = !overflowing;
    });
    window.addEventListener('resize', sync, {passive:true});
    window.addEventListener('load', sync, {once:true});
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});
  else ready();
})();

(() => {
  if (window.__nbYoutubeTrackingLoaded) return;
  window.__nbYoutubeTrackingLoaded = true;
  const players = new WeakMap();
  const watched = new WeakSet();
  const completed = new WeakSet();
  const observed = new WeakSet();
  const visible = new Set();
  let apiAttempts = 0;
  let apiLoading = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const validFrame = frame => {
    try {
      const url = new URL(frame.getAttribute('src'), window.location.href);
      const hosts = ['www.youtube.com', 'youtube.com', 'www.youtube-nocookie.com', 'youtube-nocookie.com'];
      const match = url.pathname.match(/^\/embed\/([A-Za-z0-9_-]{11})$/);
      return url.protocol === 'https:' && hosts.includes(url.hostname) && !!match &&
        match[1] === frame.getAttribute('data-nb-video-id') &&
        url.searchParams.get('enablejsapi') === '1' &&
        url.searchParams.get('origin') === window.location.origin;
    } catch (_) { return false; }
  };
  const fire = (name, frame) => {
    if (!allowed()) return;
    const test = window.nutribotaIsTestVisit?.() === true;
    const params = {
      send_to: 'G-8TF9FDW2J6',
      content_page: window.location.pathname,
      video_id: frame.getAttribute('data-nb-video-id'),
      video_provider: 'youtube',
      signup_test: test ? 'yes' : 'no',
      transport_type: 'beacon'
    };
    if (test) { params.debug_mode = true; params.traffic_type = 'internal'; }
    window.dataLayer = window.dataLayer || [];
    const gtag = typeof window.gtag === 'function' ? window.gtag : function () { window.dataLayer.push(arguments); };
    gtag('event', name + (test ? '_test' : ''), params);
  };
  const attachVisible = () => {
    if (!allowed() || typeof window.YT?.Player !== 'function') return;
    for (const frame of visible) {
      if (!frame.isConnected || players.has(frame) || !validFrame(frame)) continue;
      try {
        const record = state => {
          if (!allowed()) return;
          if (state === 1 && !watched.has(frame)) {
            watched.add(frame);
            fire('nb_video_play', frame);
          } else if (state === 0 && watched.has(frame) && !completed.has(frame)) {
            completed.add(frame);
            fire('nb_video_complete', frame);
          }
        };
        const player = new window.YT.Player(frame, {
          events: {
            onReady: event => {
              try { record(event.target.getPlayerState()); } catch (_) {}
            },
            onStateChange: event => record(event.data)
          }
        });
        players.set(frame, player);
      } catch (_) {}
    }
  };
  const start = () => {
    if (!allowed() || !Array.from(visible).some(frame => frame.isConnected && validFrame(frame))) return;
    if (typeof window.YT?.Player === 'function') { attachVisible(); return; }
    if (apiLoading || apiAttempts >= 2) return;
    apiLoading = true;
    apiAttempts += 1;
    const previousReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      apiLoading = false;
      try { if (typeof previousReady === 'function') previousReady(); } catch (_) {}
      attachVisible();
    };
    if (document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) return;
    const script = document.createElement('script');
    script.src = 'https://www.youtube.com/iframe_api';
    script.async = true;
    script.dataset.nbYoutubeApi = 'true';
    script.addEventListener('error', () => { apiLoading = false; script.remove(); }, {once:true});
    document.head.append(script);
  };
  const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
    }
    start();
  }) : null;
  const scan = () => {
    document.querySelectorAll('iframe[data-nb-video-id]').forEach(frame => {
      if (observed.has(frame) || !validFrame(frame)) return;
      observed.add(frame);
      if (observer) observer.observe(frame);
      else visible.add(frame);
    });
    start();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once:true});
  else scan();
  const ready = () => {
    if (window.Shopify?.customerPrivacy) start();
    else if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], error => { if (!error) start(); });
    }
  };
  ready();
  window.addEventListener('load', ready, {once:true});
  document.addEventListener('visitorConsentCollected', start);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('nb:video:loaded', scan);
  window.addEventListener('pageshow', scan);
})();

(() => {
  if (window.__nbAmazonListingTracking) return;
  window.__nbAmazonListingTracking = true;
  document.addEventListener('click', event => {
    if (!event.isTrusted || event.defaultPrevented) return;
    const link = event.target.closest?.('a[href]');
    if (!link || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    let destination;
    try { destination = new URL(link.href, window.location.origin); } catch (_) { return; }
    if (!['amazon.com', 'www.amazon.com'].includes(destination.hostname) || !/^\/dp\/B0HCLG1PKB\/?$/i.test(destination.pathname)) return;
    const query = new URLSearchParams(window.location.search);
    const test = window.nutribotaIsTestVisit?.() === true ||
      window.Shopify?.designMode === true ||
      Boolean(window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') ||
      (query.get('nb_test') ?? query.get('nb_qa')) === '1' || query.get('utm_source') === 'qa' ||
      query.has('preview_theme_id') || query.has('preview_script_id');
    const params = {
      send_to: 'G-8TF9FDW2J6',
      transport_type: 'beacon',
      product_asin: 'B0HCLG1PKB',
      content_page: window.location.pathname,
      link_location: (link.getAttribute('data-nb-amazon-location') || 'body_link').slice(0, 80),
      destination_host: 'www.amazon.com',
      destination_path: destination.pathname,
      content_test: test ? 'yes' : 'no'
    };
    if (test) {
      params.debug_mode = true;
      params.traffic_type = 'internal';
    }
    window.dataLayer = window.dataLayer || [];
    const gtag = typeof window.gtag === 'function' ? window.gtag : function () { window.dataLayer.push(arguments); };
    const action = link.getAttribute('data-nb-amazon-action') === 'reviews' ? 'reviews' : 'listing';
    params.amazon_action = action;
    const name = action === 'reviews' ? 'nb_amazon_reviews_click' : 'nb_amazon_listing_click';
    gtag('event', name + (test ? '_test' : ''), params);
  });
})();


(() => {
  if (window.__nbOwnerHelpTracking) return;
  window.__nbOwnerHelpTracking = true;
  document.addEventListener('click', event => {
    if (!event.isTrusted || event.defaultPrevented || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    const link = event.target.closest?.('a[data-nb-owner-help]');
    if (!link || !['directions', 'batch', 'product_support', 'amazon_orders'].includes(link.getAttribute('data-nb-owner-help'))) return;
    let destination;
    try { destination = new URL(link.href, window.location.origin); } catch (_) { return; }
    if (destination.origin !== window.location.origin) return;
    const test = window.nutribotaIsTestVisit?.() === true;
    const params = {
      send_to: 'G-8TF9FDW2J6',
      transport_type: 'beacon',
      content_page: window.location.pathname,
      destination_path: destination.pathname + destination.hash,
      link_location: 'owner_help_' + link.getAttribute('data-nb-owner-help'),
      content_test: test ? 'yes' : 'no'
    };
    if (test) { params.debug_mode = true; params.traffic_type = 'internal'; }
    window.dataLayer = window.dataLayer || [];
    const gtag = typeof window.gtag === 'function' ? window.gtag : function () { window.dataLayer.push(arguments); };
    gtag('event', test ? 'nb_owner_help_click_test' : 'nb_owner_help_click', params);
  });
})();

(() => {
  if (window.__nbCostToolTracking) return;
  window.__nbCostToolTracking = true;
  const used = new WeakSet();
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const valid = root => {
    const actions = root.querySelector('#nb-cost-actions');
    return Boolean(actions && !actions.hidden);
  };
  const fire = (name, root) => {
    if (!allowed() || !valid(root)) return false;
    const test = window.nutribotaIsTestVisit?.() === true;
    const path = window.location.pathname;
    const params = {
      send_to: 'G-8TF9FDW2J6',
      transport_type: 'beacon',
      tool_id: 'cost_per_5g',
      tool_location: path === '/pages/creatine-cost-calculator' ? 'standalone' : path.startsWith('/blogs/') ? 'article' : 'other',
      content_page: path,
      content_test: test ? 'yes' : 'no'
    };
    if (test) { params.debug_mode = true; params.traffic_type = 'internal'; }
    window.dataLayer = window.dataLayer || [];
    const gtag = typeof window.gtag === 'function' ? window.gtag : function () { window.dataLayer.push(arguments); };
    gtag('event', name + (test ? '_test' : ''), params);
    return true;
  };
  document.addEventListener('input', event => {
    if (!event.isTrusted || event.defaultPrevented || !event.target.matches?.('input[type="number"]')) return;
    const root = event.target.closest?.('#nb-cost-comparison');
    if (!root || used.has(root)) return;
    queueMicrotask(() => {
      if (!used.has(root) && fire('nb_cost_input_use', root)) used.add(root);
    });
  });
  document.addEventListener('click', event => {
    if (!event.isTrusted || event.defaultPrevented) return;
    const button = event.target.closest?.('#nb-cost-calculate, #nb-cost-share, #nb-cost-export');
    const root = button?.closest?.('#nb-cost-comparison');
    if (!root) return;
    const names = {
      'nb-cost-calculate': 'nb_cost_calculate_click',
      'nb-cost-share': 'nb_cost_share_click',
      'nb-cost-export': 'nb_cost_download_click'
    };
    const name = names[button.id];
    if (name) queueMicrotask(() => fire(name, root));
  });
})();

(() => {
  if (window.__nbVideoFacadeLoaded) return;
  window.__nbVideoFacadeLoaded = true;
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-nb-video-load]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const wrapper = link.closest('[data-nb-video-facade]');
    const template = wrapper?.querySelector('template[data-nb-video-template]');
    const original = template?.content.querySelector('iframe');
    if (!original) return;
    let source;
    try { source = new URL(original.getAttribute('src')); } catch (_) { return; }
    if (source.protocol !== 'https:' || !['www.youtube.com','youtube.com','www.youtube-nocookie.com','youtube-nocookie.com'].includes(source.hostname) || !/^\/embed\/[A-Za-z0-9_-]{11}$/.test(source.pathname)) return;
    event.preventDefault();
    const frame = original.cloneNode(true);
    frame.setAttribute('tabindex', '0');
    wrapper.replaceWith(frame);
    document.dispatchEvent(new Event('nb:video:loaded'));
    frame.focus({preventScroll:true});
  });
})();
